import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-217701d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = ["data-heap"]
const _hoisted_3 = { class: "l-row profile-creation-wizard__content-emails" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  class: "m-input",
  "data-js": "m-input"
}
const _hoisted_6 = { class: "m-input__label" }
const _hoisted_7 = ["data-js"]
const _hoisted_8 = { class: "profile-creation-wizard__content-recotext-label" }
const _hoisted_9 = { class: "l-row profile-creation-wizard__content-reassurance" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_step_item_title = _resolveComponent("step-item-title")!
  const _component_joy_highlight = _resolveComponent("joy-highlight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_step_item_title, { "is-optional": true }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.recommendations.ask.title')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.v2.recommendations.ask.legend')) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        "data-heap": _ctx.dataHeapTooltipID,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openBottomSheet && _ctx.openBottomSheet(...args)))
      }, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.recommendations.ask.help')), 9, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        class: "profile-creation-wizard__content-emails-label",
        innerHTML: _ctx.$msg('profile.creation.completion.wizard.recommendations.invitation.emails')
      }, null, 8, _hoisted_4),
      _createElementVNode("label", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$msg('recommendations.ask.subject.placeholder.v2')), 1),
        _createElementVNode("input", {
          type: "text",
          name: "recoEmails",
          autocomplete: "off",
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitRecoEmails && _ctx.emitRecoEmails(...args)))
        }, null, 32)
      ])
    ]),
    _createElementVNode("div", {
      class: "l-row profile-creation-wizard__content-recotext m-textarea",
      "data-js": _ctx.recoTextToSendJs
    }, [
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$msg('profile.creation.completion.wizard.recommendations.message.label')), 1),
      _createElementVNode("textarea", {
        ref: "recoText",
        class: "profile-creation-wizard__content-recotext-textarea",
        name: "recoTextToSend",
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitRecoText && _ctx.emitRecoText(...args)))
      }, null, 544)
    ], 8, _hoisted_7),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_joy_highlight, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$msg('profile.creation.completion.wizard.recommendations.invitation.emails.reassurance')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}